import { render, staticRenderFns } from "./AlterarPrazoVencimentoTabela.vue?vue&type=template&id=1f2ead29&lang=html"
import script from "./AlterarPrazoVencimentoTabela.vue?vue&type=script&lang=js"
export * from "./AlterarPrazoVencimentoTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports